import { Icon, IconButton, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface RangeRowProps extends React.HTMLAttributes<HTMLDivElement> {
  rowNumber: number;
  note: string;
  renderRange: () => JSX.Element;
  renderCost: () => JSX.Element;
  renderErrors: () => JSX.Element | null;
  totalTripCost: string;
  onAddNote: () => void;
  onDelete?: () => void;
}

export const RangeRow = ({
  rowNumber,
  note,
  renderRange,
  renderCost,
  renderErrors,
  totalTripCost,
  onAddNote,
  onDelete,
  className,
  ...props
}: RangeRowProps) => {
  return (
    <div className={clsx("flex flex-shrink-0 flex-row gap-x-2.5", className)} {...props}>
      <div
        className="group flex w-[167px] min-w-[167px] cursor-pointer flex-col justify-center rounded-lg bg-neutral-gray px-5 py-4 hover:ring-1 hover:ring-info"
        onClick={onAddNote}
      >
        <div className="flex flex-row items-center gap-x-1.5">
          <Typography variant="action">{`Range ${rowNumber}`}</Typography>
          <Icon name="Edit2" size="sm" className="hidden text-info group-hover:block" />
        </div>
        <Typography variant="small" className="overflow-hidden text-ellipsis text-neutral-dark-gray">
          {note}
        </Typography>
      </div>
      <div className="flex flex-1 flex-col gap-y-2 rounded-lg bg-neutral-surface-gray px-5 py-2.5">
        <div className="flex flex-col gap-2 lg:flex-row">
          <div className="flex-1">{renderRange()}</div>
          <div className="flex">{renderCost()}</div>
        </div>
        {renderErrors()}
      </div>
      <div className="flex w-[150px] min-w-[150px] flex-col justify-center gap-y-1 rounded-lg bg-neutral-gray px-5 py-4">
        <Typography variant="small" className="text-neutral-dark-gray">
          Total Trip Cost
        </Typography>
        <Typography variant="action">{totalTripCost}</Typography>
      </div>
      <div className="flex w-[34px] items-center">
        {onDelete && (
          <IconButton onClick={onDelete} iconName="Trash" variant="tertiary" className="!text-danger hover:bg-danger-light" size="sm" />
        )}
      </div>
    </div>
  );
};
